import { Component, prop } from "@kluntje/core";
import { addClass, find } from "@kluntje/js-utils/lib/dom-helpers";
import { LOADED } from "Helper/cssClasses";

/**
 * Custom Element to create a whatsapp button using airport ai
 */
class FRAWhatsappMessengerLink extends Component {
  @prop({ required: false })
  loadSDK = false;

  constructor() {
    super({
      events: [
        {
          event: "click",
          target: "this",
          handler: "handleClick",
        },
      ],

      props: {
        // Client ID for airport ai
        clientId: {
          type: "string",
          required: true,
        },
      },
    });

    this.loadingInterval = null;
  }

  afterComponentRender() {
    // on prod website SDK should already be initialized
    if (this.loadSDK) this.loadAirportAiSDK(this.clientId);
    this.waitForAirportAi();
  }

  handleClick() {
    const whatsappElement = find(this, ".airportAI-notifications-whatsapp");
    if (whatsappElement) {
      window.dataLayer.push({
        event: "gaEvent",
        eventCategory: "ChatBot",
        eventAction: "Whatsapp click",
        eventLabel: "Whatsapp",
      });
      whatsappElement.click();
    } else {
      console.warn("Whatsapp not initialized");
    }
  }

  waitForAirportAi() {
    this.loadingInterval = setInterval(this.checkLoadingStatus.bind(this), 200);
    setTimeout(() => clearInterval(this.loadingInterval), 20000);
  }

  checkLoadingStatus() {
    if (find(this, ".airportAI-notificationsPlugin-rendered")) {
      addClass(this, LOADED);
      clearInterval(this.loadingInterval);
    }
  }

  loadAirportAiSDK(clientId: string) {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.text = `(function(w,d,id){var c='${clientId}',u='https://external.airport.ai/';if(d.getElementById(id)){return;}var js=d.createElement('script');js.id=id;js.type='text/javascript';js.async=true;js.src=u+'js/sdk/web.js';var scr=d.getElementsByTagName('script')[0];scr.parentNode.insertBefore(js,scr);w.AirportAI_asyncInit=function(){w.AirportAI.init({clientId:c,url:u});};})(window,document,'airportAI-jssdk');`;
    document.body.appendChild(script);
  }
}

customElements.define("fra-e-whatsapp-messenger-link", FRAWhatsappMessengerLink);

export default FRAWhatsappMessengerLink;
